var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 12.5C27.5 13.875 26.375 15 25 15H15V25C15 26.375 13.875 27.5 12.5 27.5C11.125 27.5 10 26.375 10 25V15C10 12.2501 12.2501 10 15 10H25C26.375 10 27.5 11.125 27.5 12.5Z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 15V25C70 26.375 68.875 27.5 67.5 27.5C66.125 27.5 65 26.375 65 25V15H55C53.625 15 52.5 13.875 52.5 12.5C52.5 11.125 53.625 10 55 10H65C67.7501 10 70 12.2501 70 15Z",
    fill: "#2196F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55V65C70 67.7499 67.7501 70 65 70H55C53.625 70 52.5 68.875 52.5 67.5C52.5 66.125 53.625 65 55 65H65V55C65 53.625 66.125 52.5 67.5 52.5C68.875 52.5 70 53.625 70 55Z",
    fill: "#2196F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 67.5C27.5 68.875 26.375 70 25 70H15C12.2501 70 10 67.7499 10 65V55C10 53.625 11.125 52.5 12.5 52.5C13.875 52.5 15 53.625 15 55V65H25C26.375 65 27.5 66.125 27.5 67.5Z",
    fill: "#2196F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 40C50 41.375 48.875 42.5 47.5 42.5H42.5V47.5C42.5 48.875 41.375 50 40 50C38.625 50 37.5 48.875 37.5 47.5V42.5H32.5C31.125 42.5 30 41.375 30 40C30 38.625 31.125 37.5 32.5 37.5H37.5V32.5C37.5 31.125 38.625 30 40 30C41.375 30 42.5 31.125 42.5 32.5V37.5H47.5C48.875 37.5 50 38.625 50 40Z",
    fill: "#29B3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/Step1.78e69fc973327c678fe5579f5bc4e47f.svg";
export { ForwardRef as ReactComponent };